import TranslationModel from '../../../../../Spirit/Admin/Interfaces/Models/TranslationModel';
import AudiofilesGetListResponse from '../../../../../Spirit/Admin/Interfaces/Models/MusicService/AudiofilesGetListResponse';
import AudioFileAlbumCategoryResponse from '../../../../../Spirit/Admin/Interfaces/Models/MusicService/AudioFileAlbumCategoryResponse';

export default class AlbumGetListResponse  {
	Id: number = 0;
	IsPaid: boolean = false;
	IsSleep: boolean = false;
	ImageUrl?: string = '';
	AlbumTranslations: Array<TranslationModel> = null;
	Audiofiles: Array<AudiofilesGetListResponse> = null;
	Categories: Array<AudioFileAlbumCategoryResponse> = null;
	constructor(obj?: Partial<AlbumGetListResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
